import { Path, Svg, SvgProps } from 'react-native-svg'
import { Rect } from 'react-native-svg'

export default function EnFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Rect width="60" height="40" fill="#012169" />
      <Rect x="24" width="12" height="40" fill="#ffffff" />
      <Rect y="13.3333" width="60" height="13.3333" fill="#ffffff" />
      <Path
        d="M52.9346 40L0 4.65963V0H7.00011L60 35.3839V40H52.9346Z"
        fill="#ffffff"
      />
      <Path
        d="M7.06538 40L60 4.65963V0H52.9999L1.3411e-06 35.3839V40H7.06538Z"
        fill="#ffffff"
      />
      <Path
        d="M0 4.66212L13.0025 13.3333H20L0.00662434 0H0V4.66212Z"
        fill="#C8102E"
      />
      <Path
        d="M60 35.3828L46.9369 26.6667H40L59.9934 40H60V35.3828Z"
        fill="#C8102E"
      />
      <Path
        d="M36 11.3497L52.987 0H60L40.0266 13.3333H36V11.3497Z"
        fill="#C8102E"
      />
      <Path d="M24 28.7L7.06664 40H0L19.9734 26.6667H24V28.7Z" fill="#C8102E" />
      <Rect x="26.4" width="7.2" height="40" fill="#C8102E" />
      <Rect y="16" width="60" height="8" fill="#C8102E" />
    </Svg>
  )
}
